export default __webpack_public_path__ + "static/media/SDM.8c4b09f4.png";